import { AppIcons, AppText, Box, COLORS, Heading, Row } from "@/theme"
import type { AcceptsChildren, BoxProps, NoChildren } from "@/theme"
import { ICON_SIZES } from "@/theme/theme/icon-sizes"
import React from "react"
import { useTranslation } from "react-i18next"

export interface SuccessHandlerProps extends AcceptsChildren {
  actionElement?: React.JSX.Element
  message?: string
  title?: string
}

/**
 * A component to display a success message
 */
export function SuccessHandler({
  actionElement,
  children,
  message,
  title,
  ...rest
}: NoChildren<BoxProps> & SuccessHandlerProps): React.JSX.Element | null {
  const { t } = useTranslation()
  return (
    <Box id={"success"} py={"$2"} {...rest}>
      <Row mb={"$2"}>
        <AppIcons.Success color={COLORS.$green[500]} size={ICON_SIZES.$2xl} />
        <Box flex={1} ml={"$3"}>
          <Heading variant={"h3"}>{title ?? t("success")}</Heading>
        </Box>
        <Box ml={"auto"}>{actionElement}</Box>
      </Row>
      <AppText>{message}</AppText>
      {children}
    </Box>
  )
}
